import { createContext, useState, useMemo } from "react";
import { createTheme } from "@mui/material/styles";

export const tokens = (mode) =>({
    ...(mode ==='dark'
        ?{
            grey: {
                100: "#e6e6e6",
                200: "#cccccc",
                300: "#b3b3b3",
                400: "#999999",
                500: "#808080",
                600: "#666666",
                700: "#4d4d4d",
                800: "#333333",
                900: "#1a1a1a"
            },
            navyPrimary: {
                100: "#d2d4de",
                200: "#a5aabd",
                300: "#797f9c",
                400: "#4c557b",
                500: "#1f2a5a",
                600: "#192248",
                700: "#131936",
                800: "#0c1124",
                900: "#060812"
            },
            blueSecondary: {
                100: "#dde3ef",
                200: "#bbc7df",
                300: "#98aacf",
                400: "#768ebf",
                500: "#5472af",
                600: "#435b8c",
                700: "#324469",
                800: "#222e46",
                900: "#111723"
            },
            redAccent: {
                100: "#f8cccc",
                200: "#f19a9a",
                300: "#e96767",
                400: "#e23535",
                500: "#db0202",
                600: "#af0202",
                700: "#830101",
                800: "#580101",
                900: "#2c0000"
            },
        } : {
            grey: {
                100: "#1a1a1a",
                200: "#333333",
                300: "#4d4d4d",
                400: "#666666",
                500: "#808080",
                600: "#999999",
                700: "#b3b3b3",
                800: "#cccccc",
                900: "#e6e6e6"
            },
            navyPrimary: {
                100: "#060812",
                200: "#0c1124",
                300: "#131936",
                400: "#192248",
                500: "#1f2a5a",
                600: "#4c557b",
                700: "#797f9c",
                800: "#a5aabd",
                900: "#d2d4de"
            },
            blueSecondary: {
                100: "#111723",
                200: "#222e46",
                300: "#324469",
                400: "#435b8c",
                500: "#5472af",
                600: "#768ebf",
                700: "#98aacf",
                800: "#bbc7df",
                900: "#dde3ef"
            },
            redAccent: {
                100: "#2c0000",
                200: "#580101",
                300: "#830101",
                400: "#af0202",
                500: "#db0202",
                600: "#e23535",
                700: "#e96767",
                800: "#f19a9a",
                900: "#f8cccc"
            },
        }
    )
})


export const themeSettings = (mode) => {
    const colours = tokens(mode);
    return {
        palette:{
            mode: mode,
            ...(mode === 'dark'
                ? {
                    primary: {
                        main: colours.navyPrimary[100],
                    },
                    secondary:{
                        main: colours.blueSecondary[500],
                    },
                    neutral:{
                        dark: colours.grey[700],
                        main: colours.grey[500],
                        light: colours.grey[100]
                    },
                    background:{
                        default: colours.navyPrimary[500],
                    }
                } : {
                    primary: {
                        main: colours.navyPrimary[500],
                    },
                    secondary:{
                        main: colours.blueSecondary[500],
                    },
                    neutral:{
                        dark: colours.grey[700],
                        main: colours.grey[500],
                        light: colours.grey[100]
                    },
                    background:{
                        default: "#fcfcfc",
                    }
                }),
        },
        typography: {
            fontFamily: 'Inter, sans-serif',
            fontSize:14,
            h1: {
                fontFamily: 'Inter, sans-serif',
                fontSize: 48,
                fontWeight: 600,
                lineHeight: 1.2,
                letterSpacing: -0.5,
            },
            h2: {
                fontFamily: 'Inter, sans-serif',
                fontSize: 36,
                fontWeight: 600,
                lineHeight: 1.2,
            },
            h3: {
                fontFamily: 'Inter, sans-serif',
                fontSize: 30,
                lineHeight: 1.2,
            },
            h4: {
                fontFamily: 'Inter, sans-serif',
                fontSize: 24,
                fontWeight: 600,
                lineHeight: 1.5,
            },
            h5: {
                fontFamily: 'Inter, sans-serif',
                fontSize: 20,
                fontWeight: 600,
            },
            h6: {
                fontFamily: 'Inter, sans-serif',
                fontSize: 18,
                fontWeight: 600,
            },
            subtitle1: {
                fontFamily: 'Inter, sans-serif',
                fontSize: 18,
            },
            subtitle2: {
                fontFamily: 'Inter, sans-serif',
                fontSize: 14,
                fontWeight: 500,
            },
            body1: {
                fontFamily: 'Inter, sans-serif',
                fontSize:14,
            },
            body2: {
                fontFamily: 'Inter, sans-serif',
                fontSize: 14,
                fontWeight: 400,
            },
            caption: {
                fontFamily: 'Inter, sans-serif',
                fontSize: 12,
                fontWeight: 400,
            },
        },
    };
};

export const ColorModeContext = createContext({
    toggleColorMode: () =>{}
});

export const useMode = ()=>{
    const [mode, setMode] = useState("dark");
    const colorMode =  useMemo(
        () => ({
            toggleColorMode: () =>
                setMode((prev) => (prev === "light" ? "dark" : "light")),
        }),
        []
    );

    const theme = useMemo(() => createTheme(themeSettings(mode)), [mode]);
    return [theme, colorMode];
}